import App from './App.svelte'
import { mount } from 'svelte'
import './app.css'

const script = document.querySelector('script[type="module"][data-authenticate]')
const authMode = script?.dataset?.authenticate === 'true'

const app = mount(App, {
  target: document.getElementById('app'),
  props: { authMode }
})

export default app
